"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _PhoneNumberVerification = _interopRequireDefault(require("./PhoneNumberVerification"));
var _PhoneNumberEnter = _interopRequireDefault(require("./PhoneNumberEnter"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var STEPS = {
  PHONE_ENTER: 'phone-enter',
  CODE_VERIFICATION: 'phone-verification'
};
var PhoneNumberVerificationWidget = function PhoneNumberVerificationWidget(_ref) {
  var loading = _ref.loading,
    phoneNumber = _ref.phoneNumber,
    _ref$onSuccess = _ref.onSuccess,
    onSuccess = _ref$onSuccess === void 0 ? _lodash.noop : _ref$onSuccess,
    _ref$onPhoneNumberUpd = _ref.onPhoneNumberUpdated,
    onPhoneNumberUpdated = _ref$onPhoneNumberUpd === void 0 ? _lodash.noop : _ref$onPhoneNumberUpd,
    _ref$includePhoneInpu = _ref.includePhoneInputStep,
    includePhoneInputStep = _ref$includePhoneInpu === void 0 ? false : _ref$includePhoneInpu,
    _ref$skippable = _ref.skippable,
    skippable = _ref$skippable === void 0 ? false : _ref$skippable;
  var _useState = (0, _react.useState)(includePhoneInputStep ? STEPS.PHONE_ENTER : STEPS.CODE_VERIFICATION),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  if (step === STEPS.PHONE_ENTER) {
    return /*#__PURE__*/_react.default.createElement(_PhoneNumberEnter.default, {
      onContinue: function onContinue() {
        if (includePhoneInputStep) {
          setStep(STEPS.CODE_VERIFICATION);
          onPhoneNumberUpdated();
        } else {
          onSuccess();
        }
      },
      loading: loading,
      phoneNumber: phoneNumber,
      onDone: onSuccess
    });
  }
  if (step === STEPS.CODE_VERIFICATION) {
    return /*#__PURE__*/_react.default.createElement(_PhoneNumberVerification.default, {
      phoneNumber: phoneNumber,
      onSuccess: onSuccess,
      loading: loading,
      skippable: skippable,
      onBack: includePhoneInputStep ? function () {
        setStep(STEPS.PHONE_ENTER);
      } : null
    });
  }
  return null;
};
var _default = PhoneNumberVerificationWidget;
exports.default = _default;